// All copy for the DOS experience lives here so the components stay lean.

export const BIOS_LINES = [
  { text: "Award Modular BIOS v4.51PG, An Energy Star Ally", hot: true },
  { text: "Copyright (C) 1984-98, Award Software, Inc." },
  { text: " " },
  { text: "W6168MS V1.3 111700" },
  { text: " " },
  { text: "PENTIUM III-MMX CPU at 500 MHz          , Host Bus 100MHz", hot: true },
  { text: "Memory Test :", hasMemory: true },
  { text: " " },
  { text: "Award Plug and Play BIOS Extension v1.0A" },
  { text: "Copyright (C) 1998, Award Software, Inc." },
  { text: "   Detecting IDE Primary Master   ... ", suffix: "86B_CD00", suffixClass: "ok" },
  { text: "   Detecting IDE Primary Slave    ... None" },
  { text: "   Detecting IDE Secondary Master ... None" },
  { text: "   Detecting IDE Secondary Slave  ... None" },
  { text: " " },
  { text: "Floppy disk(s) fail (40)", hot: true },
  { text: "CMOS checksum error - Defaults loaded", hot: true },
];

// Extended MS-DOS 6.22 boot lines that stream between BIOS and prompt
export const DOS_BOOT_LINES = [
  { text: "Starting MS-DOS...", delay: 140 },
  { text: "", delay: 30 },
  { text: "HIMEM: DOS XMS Driver, Version 3.10 - 11/07/94", delay: 55 },
  { text: "Copyright (C) 1988-1993 Microsoft Corp.", delay: 25 },
  { text: "Installed A20 handler number 1.", delay: 55 },
  { text: "64K High Memory Area is available.", delay: 35 },
  { text: "", delay: 20 },
  { text: "EMM386 successfully installed.", delay: 65 },
  { text: "    Available expanded memory .............. 8192 KB", delay: 25 },
  { text: "    LIM/EMS 4.0 version .................... 4.0", delay: 25 },
  { text: "", delay: 20 },
  { text: "MSCDEX Version 2.23", delay: 60 },
  { text: "Copyright (C) Microsoft Corp. 1986-1993. All rights reserved.", delay: 25 },
  { text: "    Drive D: = Driver HEISENBERG unit 0", delay: 45 },
  { text: "", delay: 20 },
  { text: "MOUSE driver installed on IRQ 12.", delay: 55 },
  { text: "SoundBlaster 16 PnP  - Port 220h  IRQ 5  DMA 1,5", delay: 55 },
  { text: "", delay: 20 },
  { text: "CHKDSK executing...", delay: 110, isChkdsk: true },
];

export const CHKDSK_LINES = [
  "Volume HEISENBERG    created 11-17-2000 10:42a",
  "Volume Serial Number is 2A69-KM4N",
  "",
  "     536,870,912 bytes total disk space",
  "         102,400 bytes in 3 hidden files",
  "         716,800 bytes in 42 directories",
  "     419,430,912 bytes in 1,308 user files",
  "     116,620,800 bytes available on disk",
  "",
  "         16,384 bytes in each allocation unit",
  "         32,768 total allocation units on disk",
  "          7,120 available allocation units",
  "",
  "         655,360 total bytes memory",
  "         617,504 bytes free",
];

export const DOS_HEADER = `Heisenberg DOS Version 6.22
Copyright (C) Heisenberg Dynamics 2026.

C:\\HDX\\SYSTEM>BOOT COMPLETE
Generative systems environment ready.`;

export const HELP_TEXT = [
  "Available commands (case-insensitive):",
  "  HEISENBERG   Launch the Heisenberg Dynamics website",
  "  HELP         Show this list",
  "  DIR          Directory listing of C:\\HDX",
  "  TREE         Show directory tree",
  "  VER          MS-DOS version",
  "  MEM          Report memory usage",
  "  TIME         Show current system time",
  "  DATE         Show current system date",
  "  WHOAMI       Show current user",
  "  ECHO <text>  Print text to the console",
  "  TYPE README.TXT  Display readme",
  "  CLS          Clear the screen",
  "  EXIT         Power down the CRT",
];

export const DIR_TEXT = [
  " Volume in drive C is HEISENBERG",
  " Volume Serial Number is 2A69-KM4N",
  " Directory of C:\\HDX",
  "",
  "SYSTEM       <DIR>        11-17-00   9:42a",
  "AI           <DIR>        11-17-00  10:03a",
  "MODELS       <DIR>        11-17-00  10:15a",
  "PROJECTS     <DIR>        11-17-00  10:22a",
  "README   TXT      2,048   11-17-00  10:31a",
  "HEISEN~1 EXE    524,288   11-17-00  10:34a",
  "AUTOEXECBAT         412   11-17-00  10:36a",
  "CONFIG   SYS         289   11-17-00  10:36a",
  "        4 file(s)      527,037 bytes",
  "        4 dir(s)   116,620,800 bytes free",
];

export const TREE_TEXT = [
  "C:\\HDX",
  "├── SYSTEM",
  "│   ├── HIMEM.SYS",
  "│   ├── EMM386.EXE",
  "│   └── COMMAND.COM",
  "├── AI",
  "│   ├── ARCHITECTURE",
  "│   ├── WORKFLOWS",
  "│   └── GUARDRAILS",
  "├── MODELS",
  "│   ├── PRETRAIN.DAT",
  "│   └── FINETUNE.DAT",
  "└── PROJECTS",
  "    ├── COMMERCE.PRJ",
  "    ├── COMPANION.PRJ",
  "    └── SPECIALIST.PRJ",
];

export const README_TEXT = [
  "                    HEISENBERG DYNAMICS",
  "                    ===================",
  "",
  "  Specialist consultancy for generative AI harness,",
  "  architecture and infrastructure.",
  "",
  "  We design, build, harden and install production AI",
  "  systems directly inside the customer environment.",
  "  Every capability transfers. You keep the IP.",
  "",
  "  Contact: HELLO@HEISENBERGDX.COM",
  "  Domain : HEISENBERGDX.COM",
  "  Office : Casper, Wyoming - United States",
  "",
  "  --  Type HEISENBERG to launch the website  --",
];

export const MENU = [
  { key: "overview", num: "1.", label: "COMPANY OVERVIEW" },
  { key: "services", num: "2.", label: "CONSULTING SERVICES" },
  { key: "projects", num: "3.", label: "PREVIOUS PROJECTS" },
  { key: "standards", num: "4.", label: "OPERATING STANDARDS + OWNERSHIP" },
  { key: "company", num: "5.", label: "COMPANY DETAILS + CONTACT" },
];

export const VIEW_NAMES = {
  overview: "COMPANY OVERVIEW",
  services: "CONSULTING SERVICES",
  projects: "PREVIOUS PROJECTS",
  standards: "OPERATING STANDARDS + OWNERSHIP",
  company: "COMPANY DETAILS + CONTACT",
};
